import { Label } from 'components/ui/label';
import { Switch } from 'components/ui/switch';
import { ColorPicker } from 'components/Inputs/ColorPicker';
import { Direction } from 'eazychart-core';
import { useChartGridConfig } from 'hooks/useChartConfig';

export const GridForm = () => {
  const { grid, updateGridDirection, updateGridColor } = useChartGridConfig();

  return (
    <form>
      <div className="flex flex-col gap-4">
        <div className="flex items-center space-x-2">
          <Switch
            id="grid-horizontal-toggle"
            checked={grid.directions?.includes(Direction.HORIZONTAL) ?? false}
            onCheckedChange={(isEnabled) =>
              updateGridDirection(Direction.HORIZONTAL, isEnabled)
            }
          />
          <Label htmlFor="grid-horizontal-toggle" className="cursor-pointer">
            Afficher les lignes horizontales
          </Label>
        </div>
        <div className="flex items-center space-x-2">
          <Switch
            id="grid-vertical-toggle"
            checked={grid.directions?.includes(Direction.VERTICAL) ?? false}
            onCheckedChange={(isEnabled) =>
              updateGridDirection(Direction.VERTICAL, isEnabled)
            }
          />
          <Label htmlFor="grid-vertical-toggle" className="cursor-pointer">
            Afficher les lignes verticales
          </Label>
        </div>
        <div>
          <ColorPicker defaultColor={grid.color} onChange={updateGridColor} />
        </div>
      </div>
    </form>
  );
};
